import { useSearchParams } from "next/navigation";

const useShopSearchParams = () => {
  const searchParams = useSearchParams();

  return {
    deal_active: sanitize(searchParams?.getAll("deal_active")),
    product_category: sanitize(searchParams?.getAll("product_category")),
    q: sanitize(searchParams?.getAll("q")),
    shopCategory: sanitize(searchParams?.getAll("shopCategory")),
    shopName: sanitize(searchParams?.getAll("shopName")),
    showSimilar: sanitize(searchParams?.getAll("showSimilar")),
    sort: sanitize(searchParams?.getAll("sort")),
    sort_direction: sanitize(searchParams?.getAll("sort_direction")),
    strain_category: sanitize(searchParams?.getAll("strain_category")),
    strain_name: sanitize(searchParams?.getAll("strain_name")),
  };
};

const sanitize = (searchParam?: string | string[]) => {
  if (searchParam && searchParam.length > 1) {
    return searchParam;
  }
  return searchParam && searchParam[0];
};

export default useShopSearchParams;
